// src/components/common/Toggle.js
import React from 'react';

const Toggle = ({ id, checked, onChange }) => {
    return (
        <label htmlFor={id} className="flex items-center cursor-pointer">
            <div className="relative">
                <input
                    type="checkbox"
                    id={id}
                    className="sr-only"
                    checked={checked}
                    onChange={(e) => onChange(e.target.checked)}
                />
                <div className={`block w-12 h-6 rounded-full ${checked ? "bg-green-600" : "bg-gray-600"}`}></div>
                <div
                    className={`dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition transform ${
                        checked ? 'translate-x-6' : 'translate-x-0'
                    }`}
                ></div>
            </div>
        </label>
    );
};

export default Toggle;